export { default } from './EzBadge.vue';
